export const iconFontAwesomeFoodBeverageBowlRice = (
	<i className="fa-solid fa-bowl-rice"></i>
);
